<template>
  <div id="inspire">
    <content>
      <router-view></router-view>
    </content>
  </div>
</template>

<script>
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./css/global.css";

Vue.use(BootstrapVue);
import { sharedService } from "./services";
export default {
  name: "app",
  mounted() {
    let self = this;
    if (this.$route.query.api_key) {
      this.$store.dispatch("definirApiKey", this.$route.query.api_key);
      sharedService.getEmpresa().then(function (obj) {
        self.$store.dispatch("definirEmpresa", obj.obj[0]);
      });
    }
  },
  updated() {
    let self = this;
    if (this.$route.query.api_key) {
      this.$store.dispatch("definirApiKey", this.$route.query.api_key);
      sharedService.getEmpresa().then(function (obj) {
        self.$store.dispatch("definirEmpresa", obj.obj[0]);
      });
    }
  },
};
</script>

<style>
.bm-burger-button {
  cursor: pointer !important;
  height: 30px !important;
  position: absolute !important;
  top: 13px !important;
  width: 36px !important;
  left: 85% !important;
}
</style>
